// extracted by mini-css-extract-plugin
module.exports = {"LoadError":"bfl_a bhv_pw bhv_a bhv_w bhv_j bhv_q","LoadError__icon":"bfl_b bhv_uf bhv_fg bhv_rq","LoadError__message":"bfl_c bhv_fg bhv_sl"};